import React from 'react';

const Spacer = ({ orientation, seperator, seperatorColor, seperatorThickness, seperatorAlignment }) => {
    const seperatorClassName = seperator ? `${orientation === "horizontal" ? "w-full" : "h-full"}` : "";
    const seperatorStyle = seperator ? {
        background: seperatorColor,
        [orientation === "horizontal" ? "height" : "width"]: `${seperatorThickness}px`
    } : {};
    const seperatorAlignmentStyle = seperator ? {
        [orientation === "vertical" ? "justify-content" : "align-items"]: seperatorAlignment === "center" ? "center" : `flex-${seperatorAlignment}`
    } : {};
    return React.createElement("div", { className: "w-full h-full flex", style: seperatorAlignmentStyle },
        React.createElement("div", { className: seperatorClassName, style: seperatorStyle }));
};

export { Spacer as default };
//# sourceMappingURL=Spacer.js.map
